/**
 * Filtered Search Module
 *
 * Powers a search and filter toolbar that can be
 * embedded on any archive page to provide filters
 * and a relevanssi powered search.
 */
class FilteredSearch {

	constructor() {
		const self = this;

		// Existence check
		this.form = $( 'form[data-filtered-search]' );
		if ( !this.form.length ) {
			return;
		};

		// Config
		this.config = this.form.data( 'filtered-search' );

		// Filter fields
		this.search = $( '.filtered-search__input--search' );
		this.program = $( '.filtered-search__input--program' );
		this.location = $( '.filtered-search__input--location' );
		this.storyType = $( '.filtered-search__input--story-type' );
		this.resourceType = $( '.filtered-search__input--resource-type' );

		// Filter visibility rules
		this.filterVisibility();

		// Submit on filter changes
		this.program.on( 'change', $.proxy( this, 'submitOnChange' ) );
		this.location.on( 'change', $.proxy( this, 'submitOnChange' ) );
		this.storyType.on( 'change', $.proxy( this, 'submitOnChange' ) );
		this.resourceType.on( 'change', $.proxy( this, 'submitOnChange' ) );

		// Events
		this.form.on( 'submit', $.proxy( self.submit, self ) );
	}

	// Submit form on dropdown changes
	submitOnChange() {
		this.form.addClass( 'loading' );
		this.form.trigger( 'submit' );
	}

	// Filters visibility by template
	filterVisibility() {
		const template = this.config.template;

		// Adjust the filters available based on the current listing template
		switch ( template ) {
			case 'search':
				break;

			case 'stories':
				this.resourceType.remove();
				break;

			case 'resources':
				this.storyType.remove();
				break;

			case 'story-type-term':
			case 'resource-type-term':
				this.resourceType.remove();
				this.storyType.remove();
				break;
		}
	}

	// Form submit handler
	submit( event ) {
		event.preventDefault();

		const form = $( event.currentTarget );
		const inputs = form.serializeArray();

		// Remove empty values and transform to object
		const values = {};
		$.each( inputs, ( i, field ) => {
			if ( field.value === '' ) {
				return;
			};
			values[ field.name ] = field.value;
		} );

		// Search results support
		let searchPattern = RegExp( /(?:\?|&)s=(.*)(?:#|&|$)/, 'g' );
		let searchMatch = searchPattern.exec( location.search );
		if ( searchMatch ) {
			values.s = searchMatch[ 1 ];
		}

		// Strip paged values from URL
		const path = location.pathname.replace( /(\/[a-z0-9-]+)?\/page\/[\d]+\//gm, '$1/' );
		let url = path;

		// Append params unless it's an empty submission
		if ( !$.isEmptyObject( values ) ) {
			const params = `?${$.param( values )}`;
			url += params;
		}

		// Scroll to filtered-search area
		url += '#filtered-search';

		location.href = url;
	}
}

export default FilteredSearch;
